(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Attach event listeners to all list items including 'All'
    document.querySelectorAll('.brand_main_item ul li').forEach(function (li) {
      li.addEventListener('click', function () {
        const character = this.getAttribute('data-value');
        filterBrands(character);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-youtube-section"] && !Shopify.designMode) return;
  try {
    

// This function is called when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", function() {
  // Select all small video items and add click event listeners to them
  document.querySelectorAll('.small_video_item img').forEach(function(img) {
    img.addEventListener('click', function() {
      // Extract the YouTube video ID from the image's src attribute
      // Assuming the src is in the format "http://img.youtube.com/vi/{videoID}/maxresdefault.jpg"
      var videoId = this.src.match(/vi\/([^\s/]+)/)[1];
      
      // Construct the new iframe src URL with the extracted video ID
      var newIframeSrc = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&enablejsapi=1';

      // Find the iframe in the first video item and update its src attribute
      var firstVideoIframe = document.querySelector('.first_video_item iframe');
      if(firstVideoIframe) {
        firstVideoIframe.src = newIframeSrc;
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

 document.addEventListener('DOMContentLoaded', function() {
    var links = document.querySelectorAll('.grandchild-nav__item');

    links.forEach(function(link) {
      link.addEventListener('click', function(e) {
        var selectedModelName = e.target.getAttribute('data-title');
        var redirectUrl = 'https://fueled-utv-9628.myshopify.com/pages/make-model-categories';

        // Save the model name to localStorage
        localStorage.setItem('selectedModelName', selectedModelName);

        // Redirect to the new URL
        window.location.href = redirectUrl;
      });
    });
  });

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    



 document.addEventListener('DOMContentLoaded', function() {
  
  var modelName = localStorage.getItem('selectedModelName');
  
  
  var modelPlaceholder = document.getElementById('dynamic-model-name-target');
  if (modelName && modelPlaceholder) {
    
    modelPlaceholder.textContent = modelName;
  }
});
  
  
  } catch(e) { console.error(e); }
})();
})();
